import { useQuery } from "react-query";
import { fetchListingsData } from "./api";

export function useListings(filters, options={}) {
    return useQuery(["ListingsData", filters], () => fetchListingsData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }